const imageFormats = [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    "svg",
    "tiff",
    "tif",
    "heic",
    "heif",
    "ico",
    "avif",
    "jfif",
    "pjpeg",
    "pjp",
    "raw",
    "cr2",
    "nef",
    "orf",
    "sr2"
  ];


const ImageFormatTypes = new Set(imageFormats);

export { ImageFormatTypes };
  